import React from 'react';
import styles from './styles.module.scss';
import { ButtonContained } from '../buttons/buttonContained';
import { Image } from '../image';

interface SectionWithActionButtonProps {
	title: string;
	subtitle?: string[];
	buttonText: string;
	icon?: { src: string; size?: string };
	placeholder?: string;
	onClick: () => void;
}

export const SectionWithActionButton: React.FC<
	SectionWithActionButtonProps
> = ({ title, subtitle = [], buttonText, icon, placeholder, onClick }) => {
	return (
		<div className={`${styles['section-with-action-button']} ${(subtitle.length <= 0&&!icon) && styles['_noborder']}`}>
			<div>
				<h2 className={styles['section-with-action-button__title']}>
					{title}
				</h2>
        {(subtitle.length > 0||icon) && 
				<div
					className={styles['section-with-action-button__subtitles']}
				>
					{icon && (
						<div className={'section-with-action-button__icon'}>
							<Image src={icon.src} size={icon.size} />
						</div>
					)}
					<div
						className={
							styles['section-with-action-button__subtitles-list']
						}
					>
						{subtitle.length > 0 ? (
							subtitle.map((sub, index) => (
								<div
									key={index}
									className={
										styles[
											'section-with-action-button__subtitle'
										]
									}
								>
									{sub}
								</div>
							))
						) : (
							<div className="section-with-action-button__placeholder">
								{placeholder && <p>{placeholder}</p>}
							</div>
						)}
					</div>
				</div>
        }
			</div>
			<div>
				<ButtonContained variant={'secondary'} onClick={onClick}>
					{buttonText}
				</ButtonContained>
			</div>
		</div>
	);
};
